import { graphql } from "~/gql";

export const CREATE_LIBRARY_DISBURSEMENT = graphql(/* GraphQL */ `
  mutation CreateLibraryDisbursement($data: LibraryDisbursementCreate!) {
    createLibraryDisbursement(data: $data) {
      id
      name
      amount
      vatStatus
    }
  }
`);
